import { render, staticRenderFns } from "./Grafica.vue?vue&type=template&id=2918cb50&scoped=true&"
import script from "./Grafica.vue?vue&type=script&lang=js&"
export * from "./Grafica.vue?vue&type=script&lang=js&"
import style0 from "./Grafica.vue?vue&type=style&index=0&id=2918cb50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2918cb50",
  null
  
)

export default component.exports